import "./CircularLoader.css";

export function CircularLoader() {
  return (
    <div className="circular-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
